export class CheckMailModel {
    urgent: number
    protected_: number

    constructor(
        urgent: number,
        protected_: number
    ) {
        this.urgent = urgent
        this.protected_ = protected_
    }
}